<template>
	<div>
		<div class="row">
			<div class="input-field col s12 m12 12 x12">
				<label>Título</label>
			</div>
			<div class="input-field col s12 m12 l12 x12">
				{{proj.titulo}}
			</div>
			<div class="input-field col s12 m12 12 x12">
				<label>Palavras-Chave</label>
			</div>
			<div class="input-field col s12 m12 l12 x12">
				{{proj.palavras_chave}}
			</div>
			<div class="input-field col s12 m12 12 x12">
				<label>Resumo</label>
			</div>
			<div class="input-field col s12 m12 l12 x12">
				{{proj.resumo}}
			</div>
			<div class="input-field col s12 m12 12 x12">
				<a :href="'/projetos/pdf/' + proj.id" target='_blank' class="btn"><i class="material-icons left">assignment_returned</i>PDF da Ação</a>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s4 m4 l4 x4">
				<label>A ação adequado a alunos da graduação?</label>
			</div>
			<div class="input-field col s2 m2 l2 x2">
				<select name="graduacao" id="graduacao" :disabled='this.impedido == true || justificativa' v-model="proj.graduacao" required class="browser-default select_sec" v-on:change="verificarPertinencia()">
					<option value="" disabled>Selecione</option>
					<option value="false">Não</option>
					<option value="true">Sim</option>
				</select>
			</div>
			<div class="input-field col s4 m4 l4 x4">
				<label>A ação tem natureza artístico-cultural?</label>
			</div>
			<div class="input-field col s2 m2 l2 x2">
				<select name="natureza" id="natureza" :disabled='this.impedido == true || justificativa' v-model="proj.natureza" required class="browser-default select_sec" v-on:change="verificarPertinencia()">
					<option value="" disabled>Selecione</option>
					<option value="false">Não</option>
					<option value="true">Sim</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s4 m4 l4 x4">
				<label>A ação apresenta algum aspecto de extensão?</label>
			</div>
			<div class="input-field col s2 m2 l2 x2">
				<select name="extensao" :disabled='this.impedido == true || justificativa' v-model="proj.extensao" required class="browser-default select_sec">
					<option value="" disabled>Selecione</option>
					<option value="false">Não</option>
					<option value="true">Sim</option>
				</select>
			</div>
			<div class="input-field col s4 m4 l4 x4">
				<label>A ação é pertinente?</label>
			</div>
			<div class="input-field col s2 m2 l2 x2">
				<select name="pertinente" id="pertinente" :disabled='this.impedido == true || justificativa' v-model="proj.pertinente" required class="browser-default select_sec">
					<option value="" disabled>Selecione</option>
					<option value="false">Não</option>
					<option value="true" v-if='proj.graduacao != "false" && proj.natureza != "false"'>Sim</option>
				</select>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m12 l12 x12">
				<textarea name="justificativa" :disabled='this.impedido == true || justificativa' id="justificativa" required v-model="proj.justificativa_pertinencia" class="materialize-textarea" maxlength="2000" data-length="2000"></textarea>
				<label for="justificativa" class='active'>Justificativa</label>
			</div>
		</div>
		
		<div class="row" v-if='this.todos == "true"'>
			<div class="col s12 m12 l12 x12">
				<label>Parecer</label>
				<p v-if='proj.pertinente == "true" || proj.pertinente == true'>{{aprovado}}</p>
				<p v-if='proj.pertinente == "false" || proj.pertinente == false'>{{reprovado}}</p>
				<textarea name="parecer" id="parecer" :disabled='this.impedido == true' required v-model="proj.parecer" class="materialize-textarea" maxlength="2000" data-length="2000"></textarea>				
			</div>
		</div>
		<div class="row" v-if='this.todos == "true" && pdf'>
			<div class="input-field col s12 m12 l12 x12">
				<a :href="'/pertinencia/pdf/' + proj.id" class="btn"><i class="material-icons left">remove_red_eye</i>PDF do Parecer</a>
			</div>
		</div>
		
		<center>
			<div class="row" v-if="this.impedido != true && !justificativa">
				
				<div class="input-field col s6 m6 l6 xl6">
					<button type="submit" class="btn" id='submit'>
						<i class="material-icons left">save</i>Salvar
					</button>
				</div>
				<div class="input-field col s6 m6 l6 xl6">
					<button type="reset" class="btn indigo">
						<i class="material-icons right">clear</i>Limpar
					</button>
				</div>
			</div>
		</center>
			
		<div class="row">
			<center>
				<a :disabled='this.impedido == true || justificativa'  class="btn teal" @click="justificativa = true;"><i class="material-icons left">block</i>Declarar impedimento</a>
			</center>
			<div v-if='justificativa' class="input-field col s12 m12 l12 x12">
				<textarea name="impedimento" id="impedimento" required class="materialize-textarea" maxlength="500" data-length="500" @focus="colocarContador();" v-model='texto'></textarea>
				<label for="impedimento" class='active'>Justificativa para o impedimento</label>
			</div>	
			<div v-if='justificativa && texto.length' class="input-field col s12 m12 l12 x12">
				<center>
					<a :disabled='this.impedido == true' class="btn teal" :href="'/pertinencia/impedido/' + proj.id + '/' + texto" onclick="return confirmarImpedimento();"><i class="material-icons left">done</i>Enviar</a>
				</center>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		name: "VuePertinenciaForm",
		props: [
			'projeto',
			'impedido',
			'todos',
			'aprovado',
			'reprovado'
		],
		data () {
			return {
				proj: JSON.parse(this.projeto),
				pdf: false,
				justificativa: false,
				texto: ''
			}
		},
		methods: {
			verificarPertinencia() {
				if ($("#graduacao").val() == "false" || $("#natureza").val() == "false")
					this.proj.pertinente = false;
			},
			colocarContador() { 
				$("#impedimento").characterCounter();
			}
		},
		mounted() {
			$("#justificativa").characterCounter();
			if (this.todos)
				$("#parecer").characterCounter();
			if (this.proj.graduacao == false)
				this.proj.graduacao = "false";
			if (this.proj.natureza == false)
				this.proj.natureza = "false";
			this.pdf = (this.proj.parecer != null);
		}
	}
</script>